export default __webpack_public_path__ + "static/media/markit-iq-mobile.2827745c.png";